"use strict";

angular.module('app.directives.sceneRow', [])

    .directive("sceneRow", ['SceneOverviewService',
        function (SceneOverviewService) {
            return {
                restrict: 'A',
                templateUrl: function (tElement, tAttrs) {
                    if (tAttrs) {
                       switch (tAttrs.mode) {
                            case "'edit'":
                                return 'views/scene/item_row.edit.html';
                            case "'sort'":
                                return 'views/scene/item_row.sort.html';
                            default:
                                return 'views/scene/item_row.html';
                        }
                    }
                },
                scope: {
                    s: '=scene',
                    mode: '=?',
                    sceneList : '=sceneList'
                },
                controller: function ($scope, $element, $attrs, $state) {
                    'ngInject';

                    // set $UI variable for scene
                    if (!$scope.s['$UI']) {
                        $scope.s['$UI'] = {};
                    }

                    switch ($scope.mode) {
                        case "edit":
                            $scope.editmode = true;
                            $scope.sortmode = false;
                            break;
                        case "sort":
                            $scope.editmode = false;
                            $scope.sortmode = true;
                            break;
                        default:
                            $scope.editmode = false;
                            $scope.sortmode = false;
                            break;
                    }

                    $scope.clickScene = function (s) {
                        if ($scope.sortmode) {
                            return false;
                        }
                        if (!$scope.sortmode && !$scope.editmode) {
                            $state.go('scene.detail', {sceneId: s.SceneId, scene: s,sceneList:$scope.sceneList});
                        }
                        s.$UI.editMode = true;
                    };

                    $scope.playSceneOnce = function () {
                        $scope.s.$execute();

                    };

                    $scope.deleteItemFromList = function () {
                        $scope.s.$UI.delete = true;
                    };

                    $scope.EnableDisableScene = function (e) {
                        SceneOverviewService.cancelRefreshOfScenes();
                        $scope.s.$enableDisable();
                    };

                    $scope.sceneNameChanged = function (scene, oldName) {
                        if (scene.DisplayName !== oldName) {
                            scene.$UI.isChanged = true;
                        }
                    };
                }
            }
        }
    ]);
